export default function (/**@type {ApisauceInstance} */ api) {
  const getAllSkus = (paging) => api.get(`Sku/search-dashboard`, paging);
  const getSkus = (paging) => api.get(`Sku`, paging);
  const createSku = (payload) => api.post(`Sku/create`, payload);
  const editSku = ({ id, payload }) => api.put(`Sku/edit`, payload);
  const deleteSku = (id) => api.delete(`Sku/remove/${id}`);

  return {
    Skus: {
      getAllSkus,
      getSkus,
      createSku,
      editSku,
      deleteSku,
    },
  };
}
